/**
 * Absolute public URL for a blog post (custom domain, heal.me/{slug}, or dev HOST).
 *
 * @param {string} postSlug
 * @param {string} [publicSiteBaseUrl] - from practice.url (e.g. https://pro.com or http://localhost:3000/chris-pro)
 */
export function buildPublicBlogPostUrl(postSlug, publicSiteBaseUrl) {
  const path = `/blog/${encodeURIComponent(postSlug)}`
  if (!publicSiteBaseUrl) return path

  const base = publicSiteBaseUrl.replace(/\/$/, "")
  if (/^https?:\/\//i.test(base)) {
    return `${base}${path}`
  }

  const origin = typeof window !== "undefined" ? window.location.origin : ""
  const basePath = base.startsWith("/") ? base : `/${base}`
  return `${origin}${basePath}${path}`
}
